/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */
import { createApi } from "@reduxjs/toolkit/dist/query/react";

import { getCSRFTokenHeader } from "common/hooks";
import { CONTENT_TYPE_JSON, RequestMethod } from "store/types";
import { replacer, transformResponse } from "common/util";
import Rate from "pages/Schedule/types/Rate";
import { dynamicBaseQuery } from "store/api/utils/dynamicBaseQuery";

export interface ShiftRatePayload {
    shiftId: string;
    vanId: string | null;
    startTime: string;
    endTime: string;
}
interface RatesPayload {
    url: string;
    shifts: ShiftRatePayload[];
}

export const ratesApi = createApi({
    baseQuery: dynamicBaseQuery,
    reducerPath: "ratesApi",
    endpoints: (builder) => ({
        fetchRates: builder.mutation<Rate[], RatesPayload>({
            query: ({ url, shifts }) => ({
                body: JSON.parse(JSON.stringify({ shifts }, replacer)),
                headers: {
                    ...CONTENT_TYPE_JSON,
                    ...getCSRFTokenHeader(),
                },
                method: RequestMethod.POST,
                responseType: "text",
                url,
            }),
            transformResponse: (response: Rate[]) => {
                const data = transformResponse(response);
                return data.rates;
            },
        }),
    }),
});

export const { useFetchRatesMutation } = ratesApi;
